import { render, staticRenderFns } from "./BaseFormLoading.vue?vue&type=template&id=b96d08d4&scoped=true&"
import script from "./BaseFormLoading.vue?vue&type=script&lang=js&"
export * from "./BaseFormLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96d08d4",
  null
  
)

export default component.exports